import React, { useState, useEffect } from 'react';

import './CardholderAccordion.sass';

import { ReactComponent as ArrowAlt } from '../static/img/arrow-alt.svg';
import { ReactComponent as SafePayment } from '../static/img/safe-payment.svg';

export default ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 500px)');
    const handleChange = e => setIsMobile(e.matches);

    setIsMobile(mediaQuery.matches);

    mediaQuery.addEventListener('change', handleChange);

    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  const handleClick = () => setIsOpen(!isOpen);

  return (
    <div className="accordion">
      <div className="accordion__header">
        <div className="accordion__content-wrapper">
          <SafePayment />
          <div className="accordion__text">
            <h4>Add card details</h4>
            {!isMobile && <p>Quick and secure payment set-up for hospital charges</p>}
          </div>
        </div>
        <button
          className="accordion__btn"
          aria-label={isOpen ? 'Close card details section' : 'Open card details section'}
          onClick={handleClick}
          type="button"
        >
          <ArrowAlt style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }} />
        </button>
      </div>
      {isMobile && (
        <p className="accordion__sub-text">Quick and secure payment set-up for hospital charges</p>
      )}
      {isOpen && <div className="accordion__content">{children}</div>}
    </div>
  );
};
